export default __webpack_public_path__ + "static/dynamic-ai-2ef63a5897337c2a3c96d7733d5ac9a7.png";